// @flow
import React, { PureComponent } from 'react';
import SocialCard from 'containers/social/SocialCardContainer';
import type { SocialContent } from 'types/SocialContent';
import { FacebookProvider, InstagramProvider, TwitterProvider, AllProvider } from 'constants/socialConstants';
import ButtonIcon from 'components/fragments/button/ButtonIcon';
import { getValidSocialCards } from 'utils/socialUtils';
import type { liensRsType } from 'types/Settings';

type Props = {
  socialCards: Array<SocialContent>,
  showCards: boolean,
  liensRs: liensRsType
};

type State = {
  provider: string,
  page: number,
  compteRS: number,
};

class SocialCardNavigator extends PureComponent<Props, State> {
  state: State = {
    provider: AllProvider,
    page: 0, 
    compteRS: 0,
  };

  componentDidMount() {
    const hasfbposts = getValidSocialCards(this.props.socialCards, FacebookProvider).length > 0;
    const hastwposts = getValidSocialCards(this.props.socialCards, TwitterProvider).length > 0;
    const hasinstaposts = getValidSocialCards(this.props.socialCards, InstagramProvider).length > 0;
    let compteRS = 0;
    if (hasfbposts) {
      compteRS++;
    }
    if (hastwposts) {
      compteRS++;
    }
    if (hasinstaposts) {
      compteRS++;
    }
    if (compteRS === 1) {
      if (hasfbposts) {
        this.setState({provider: FacebookProvider});
      } else if (hastwposts) {
        this.setState({provider: TwitterProvider});
      } else if (hasinstaposts) {
        this.setState({provider: InstagramProvider});
      }
    }
    this.setState({compteRS: compteRS});
  }

  componentDidUpdate() {
    const hasfbposts = getValidSocialCards(this.props.socialCards, FacebookProvider).length > 0;
    const hastwposts = getValidSocialCards(this.props.socialCards, TwitterProvider).length > 0;
    const hasinstaposts = getValidSocialCards(this.props.socialCards, InstagramProvider).length > 0;
    let compteRS = 0;
    if (hasfbposts) {
      compteRS++;
    }
    if (hastwposts) {
      compteRS++;
    }
    if (hasinstaposts) {
      compteRS++;
    }
    if (compteRS === 1) {
      if (hasfbposts) {
        this.setState({provider: FacebookProvider});
      } else if (hastwposts) {
        this.setState({provider: TwitterProvider});
      } else if (hasinstaposts) {
        this.setState({provider: InstagramProvider});
      }
    }
    this.setState({compteRS: compteRS});
  }


  renderCards = (socialCards: Array<SocialContent>): Array<?React$Element<*>> => {
    return socialCards.map((c: SocialContent, index: number) => {
      if (c.type === FacebookProvider && c.description === '') {
        return null;
      }
      return <SocialCard key={c.id} content={c} transparent={index === 3} />;
    });
  };

  onClicked = (provider: string) => (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ provider, page: 0 });
  };

  setPage = (page: number) => (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ page });
  };

  render() {
    const { fb_lien, twitter_lien, instagram_lien } = this.props.liensRs;
    const { provider } = this.state;
    const validSocialCards = getValidSocialCards(this.props.socialCards, this.state.provider);
    const hasposts = this.props.socialCards.length > 0;;
    const hasfbposts = getValidSocialCards(this.props.socialCards, FacebookProvider).length > 0;
    const hastwposts = getValidSocialCards(this.props.socialCards, TwitterProvider).length > 0;
    const hasinstaposts = getValidSocialCards(this.props.socialCards, InstagramProvider).length > 0;
    const displayedSocialCards = validSocialCards.slice(this.state.page * 3, 4 + this.state.page * 3);
    const maxPage = Math.max(Math.ceil(validSocialCards.length / 3) - 1, 0);
    const compteRS = this.state.compteRS;

    return (
      <div className="col col-md-8 col-lg-9">
        <div className="live-feed__tag mb-2">
          { hasposts && compteRS > 1 && 
            <a
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === AllProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(AllProvider)}
            >
              Tous
            </a>
          }
          {
            hasfbposts && fb_lien !== '' &&
            <a
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === FacebookProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(FacebookProvider)}
            >
              Facebook
            </a>
          }
          {
            hastwposts && twitter_lien !== '' &&
            <a
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === TwitterProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(TwitterProvider)}
            >
              Twitter
            </a>
          }
          {
            hasinstaposts && instagram_lien !== '' &&
            <a
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === InstagramProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(InstagramProvider)}
            >
              Instagram
            </a>
          }
        </div>
        <div className="carousel">
        { hasposts &&
          <div className="carousel__nav">
            <ButtonIcon
              label={null}
              url={null}
              isDark
              icon="icon-arrow-left"
              isDisabled={this.state.page === 0 || !this.props.showCards}
              onClick={this.setPage(this.state.page - 1)}
              titleSEO="Précédent"
            />
            <ButtonIcon
              label={null}
              url={null}
              isDark
              icon="icon-arrow-right"
              isDisabled={this.state.page === maxPage || !this.props.showCards}
              onClick={this.setPage(this.state.page + 1)}
              titleSEO="Suivant"
            />
          </div>
        }
          <div className="carousel__wrapper">{this.props.showCards && this.renderCards(displayedSocialCards)}</div>
        </div>
      </div>
    );
  }
}

export default SocialCardNavigator;
